"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import cardActionsClasses from "@mui/material/CardActions/cardActionsClasses";
import cardHeaderClasses from "@mui/material/CardHeader/cardHeaderClasses";
import cardContentClasses from "@mui/material/CardContent/cardContentClasses";
import InnerCardHorizontalContent from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useCheckThemeContext } from "../../hooks/useCheckThemeContext";
export const cardHorizontalContentClasses = {
    root: "Pxl-CardHorizontalContent-root",
};
const StyledCardHorizontalContent = styled(InnerCardHorizontalContent)(({ theme }) => {
    const dt = theme.pixel;
    return {
        display: "flex",
        flexDirection: "column",
        gap: dt.inline.small,
        padding: `${dt.stacked.medium} ${dt.space.inline.small}`,
        [`.${cardActionsClasses.root}`]: {
            margin: `-${dt.stacked.medium} -${dt.space.inline.small} -${dt.stacked.medium} -${dt.space.inline.small}`,
            padding: `${dt.stacked.medium} ${dt.space.inline.small}`,
            "* + &": {
                marginTop: 0,
            },
            "&:has(+ *)": {
                marginBottom: 0,
            },
        },
        [`.${cardHeaderClasses.root}`]: {
            paddingBottom: 0,
        },
        [`.${cardContentClasses.root}`]: {
            paddingTop: dt.space.inline.xSmall3,
        },
    };
});
export const CardHorizontalContent = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    useCheckThemeContext("CardHorizontalContent");
    return (_jsx(StyledCardHorizontalContent, Object.assign({}, props, { className: `${cardHorizontalContentClasses.root} ${props.className}`, "data-pixel": "CardHorizontalContent", ref: ref, children: children })));
});
